import { getLanguage } from "@/plugins/i18n"

/**
 * @description: 数字千分符分割
 * @param {*} val
 * @return {*}
 * @author:
 */
export const mumFormat = val => {
  let res = ""
  if (val === "" || val === undefined || val === null) {
    res = "--"
  }
  res = val.toString().replace(/\d+/, function (n) {
    // 先提取整数部分
    return n.replace(/(\d)(?=(\d{3})+$)/g, function ($1) {
      return $1 + ","
    })
  })
  return res
}

export const formatAddressLabel = val => {
  const lang = getLanguage()
  if (val === "Home") {
    return lang === "zh_HK" ? "住家" : "Home"
  }

  if (val === "Work") {
    return lang === "zh_HK" ? "工作地址" : "Work"
  }

  return val
}
